import { FormGroup } from '@angular/forms';
import { isFormGroup } from './is-form-group.function';

/**
 * Marks all controls in formGroup as touched to invoke validation
 * @param formGroup FormGroup to mark
 */
export function markForValidation(formGroup: FormGroup): void {
  if (!formGroup) {
    return;
  }

  for (const controlName of Object.keys(formGroup.controls)) {
    const control = formGroup.controls[controlName];
    control.markAsTouched({ onlySelf: true });

    if (isFormGroup(control)) {
      markForValidation(control);
    }
  }
}
